// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__21iic","productName":"Table_productName__2Y1vq"};